(function () {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  function formatMoney(cents) {
    const amount = (Number(cents) / 100).toFixed(2).replace(".", ",");
    return amount + " €";
  }

  function toggle(el, on) {
    if (!el) return;
    el.classList.toggle("is-open", on);
    el.setAttribute("aria-hidden", on ? "false" : "true");
  }

  const menuBtn = qs("[data-menu-toggle]");
  const mobileNav = qs("[data-mobile-nav]");
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener("click", () => {
      const open = !mobileNav.classList.contains("is-open");
      toggle(mobileNav, open);
      menuBtn.setAttribute("aria-expanded", String(open));
    });
  }

  const searchBtn = qs("[data-search-toggle]");
  const searchPanel = qs("[data-search-panel]");
  if (searchBtn && searchPanel) {
    searchBtn.addEventListener("click", () => {
      const open = !searchPanel.classList.contains("is-open");
      toggle(searchPanel, open);
      if (open) {
        const input = qs("input", searchPanel);
        if (input) input.focus();
      }
    });
  }

  const overlay = qs("[data-cart-overlay]");
  const drawer = qs("[data-cart-drawer]");
  const openers = qsa("[data-cart-open]");
  const closers = qsa("[data-cart-close]");

  function openCart() {
    toggle(overlay, true);
    toggle(drawer, true);
    document.body.style.overflow = "hidden";
    refreshCart();
  }
  function closeCart() {
    toggle(overlay, false);
    toggle(drawer, false);
    document.body.style.overflow = "";
  }
  openers.forEach((b) => {
    b.addEventListener("click", (e) => {
      if (b.tagName === "A" && b.getAttribute("href")) return;
      e.preventDefault();
      openCart();
    });
  });
  closers.forEach((b) => b.addEventListener("click", closeCart));
  if (overlay) overlay.addEventListener("click", closeCart);

  function updateCount(count) {
    qsa("[data-cart-count]").forEach((el) => {
      el.textContent = count;
      el.hidden = Number(count) === 0;
    });
  }

  function renderCart(cart) {
    const body = qs("[data-cart-items]");
    const total = qs("[data-cart-total]");
    if (total) total.textContent = formatMoney(cart.total_price);
    updateCount(cart.item_count);
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="empty">Su carrito está vacío.</p>';
      return;
    }
    body.innerHTML = cart.items
      .map(
        (item) => `
      <div class="drawer-item">
        <img src="${item.image || ""}" alt="">
        <div>
          <a href="${item.url}">${item.product_title}</a>
          <div class="price">${formatMoney(item.final_line_price)}</div>
          <div>Qté ${item.quantity}</div>
        </div>
      </div>`
      )
      .join("");
  }

  async function refreshCart() {
    try {
      const cart = await fetch("/cart.js").then((r) => r.json());
      renderCart(cart);
    } catch (e) {}
  }

  async function addToCart(id, qty = 1) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id, quantity: qty }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      alert(err.description || "No se ha podido añadir este artículo.");
      return false;
    }
    window.location.href = "/cart";
    return true;
  }

  qsa("[data-add-form]").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const id = form.querySelector('[name="id"]').value;
      const qtyEl = form.querySelector('[name="quantity"]');
      const qty = qtyEl ? Number(qtyEl.value || 1) : 1;
      const btn = form.querySelector("[type=submit]");
      if (btn) {
        btn.disabled = true;
        btn.dataset.label = btn.textContent;
        btn.textContent = "Añadiendo…";
      }
      const ok = await addToCart(id, qty);
      if (!ok && btn) {
        btn.disabled = false;
        btn.textContent = btn.dataset.label || "Añadir al carrito";
      }
    });
  });

  qsa("[data-qty]").forEach((wrap) => {
    wrap.addEventListener("click", (e) => {
      const btn = e.target.closest("button");
      if (!btn) return;
      const input = wrap.querySelector("input");
      const next = Math.max(1, Number(input.value || 1) + Number(btn.dataset.delta));
      input.value = next;
    });
  });

  refreshCart();

  const slider = qs("[data-hero-slider]");
  if (slider) {
    const slides = qsa("[data-hero-slide]", slider);
    const dots = qsa("[data-hero-dot]", slider);
    let i = 0;
    let timer;
    const show = (n) => {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle("is-active", idx === i));
      dots.forEach((d, idx) => d.classList.toggle("is-active", idx === i));
    };
    const start = () => {
      clearInterval(timer);
      timer = setInterval(() => show(i + 1), 6500);
    };
    dots.forEach((d, idx) => d.addEventListener("click", () => { show(idx); start(); }));
    const prev = qs("[data-hero-prev]", slider);
    const next = qs("[data-hero-next]", slider);
    if (prev) prev.addEventListener("click", () => { show(i - 1); start(); });
    if (next) next.addEventListener("click", () => { show(i + 1); start(); });
    start();
  }
})();
